import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AuthLogo from "./AuthLogo";

const LoginView = ({
  siteName,
  loginEmail,
  loginPassword,
  submitting,
  inlineError,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onForgotClick,
  onRegisterClick
}) => {
  const { t } = useTranslation("common");

  return (
    <>
      <AuthLogo siteName={siteName} />

      <h1 className="auth-title">{t("Welcome back")}</h1>
      <p className="auth-subtitle">{t("Sign in to your account to continue")}</p>

      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="login-email">
            {t("Email address")}
          </label>
          <input
            type="email"
            id="login-email"
            className="form-control"
            placeholder={t("you@company.com")}
            value={loginEmail}
            onChange={(event) => onEmailChange(event.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="form-group">
          <label className="form-label auth-label-row" htmlFor="login-password">
            <span>{t("Password")}</span>
            <button type="button" onClick={onForgotClick}>
              {t("Forgot password?")}
            </button>
          </label>
          <input
            type="password"
            id="login-password"
            className="form-control"
            placeholder="••••••••"
            value={loginPassword}
            onChange={(event) => onPasswordChange(event.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        <div className={`auth-inline-error ${inlineError ? "visible" : ""}`}>{inlineError}</div>

        <button type="submit" className="btn btn-gradient btn-lg btn-full" disabled={submitting}>
          {submitting ? t("Signing in…") : t("Sign In")}
        </button>
      </form>

      <div className="divider">{t("or")}</div>

      <div className="auth-footer">
        <span>{t("Don't have an account?")} </span>
        <button type="button" onClick={onRegisterClick}>
          {t("Create one free →")}
        </button>
      </div>
    </>
  );
};

LoginView.propTypes = {
  siteName: PropTypes.string.isRequired,
  loginEmail: PropTypes.string.isRequired,
  loginPassword: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  inlineError: PropTypes.string,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onForgotClick: PropTypes.func.isRequired,
  onRegisterClick: PropTypes.func.isRequired
};

export default LoginView;
